export const WEB_CONTENT = '56';
